import { render, staticRenderFns } from "./ArticleSecond.vue?vue&type=template&id=0319b546&scoped=true&"
import script from "./ArticleSecond.vue?vue&type=script&lang=js&"
export * from "./ArticleSecond.vue?vue&type=script&lang=js&"
import style0 from "./ArticleSecond.vue?vue&type=style&index=0&id=0319b546&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0319b546",
  null
  
)

export default component.exports